import { Dimension } from "../../../components/FileUploadComponent/constants";

export const FileUploadItem = {
	key: "image",
	label: "Mobil Banner",
	maxFileSize: "20971520",
	extensions: ["jpeg", "jpg", "png"],
	default: "imageUrl",
	isRequired: true,
	dimensions: {
		upper: [{ width: 768, height: 1024 }] as Dimension[],
		lower: [{ width: 576, height: 576 }] as Dimension[]
	}
};

